import React from 'react'

export const renewSubscriptionSchema = [

{
    id:1,
    name:'Email',
    type:'text',
    labelTitle:'Email o Teléfono'
}
]